import {
  useState,
} from "react";

import {
  useLanguage,
} from "../i18n/LanguageContext";

import contactTranslations
  from "../i18n/contactTranslations";


export default function ContactPage({
  session,
  goBackToHome,
}) {

  const { language } =
    useLanguage();

  const content =
    contactTranslations[language] ||
    contactTranslations.en;


  const [
    name,
    setName,
  ] = useState(
    session?.user?.user_metadata?.full_name ||
    session?.user?.user_metadata?.username ||
    ""
  );

  const [
    email,
    setEmail,
  ] = useState(
    session?.user?.email ||
    ""
  );

  const [
    subject,
    setSubject,
  ] = useState("");

  const [
    message,
    setMessage,
  ] = useState("");

  const [
    submitting,
    setSubmitting,
  ] = useState(false);


  const handleSubmit =
    async (event) => {
      event.preventDefault();

      if (
        !name.trim() ||
        !email.trim() ||
        !subject.trim() ||
        !message.trim()
      ) {
        alert(
          content.validationError
        );

        return;
      }

      setSubmitting(true);

      try {
        const response =
          await fetch("/api/contact", {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",
            },

            body: JSON.stringify({
              name,
              email,
              subject,
              message,
            }),
          });


        const data =
          await response.json();


        if (!response.ok) {
          throw new Error(
            data?.error ||
            content.sendError
          );
        }


        alert(
          content.successMessage
        );


        setSubject("");
        setMessage("");

      } catch (error) {
        console.error(
          "Contact form error:",
          error
        );

        alert(
          error.message ||
          content.sendError
        );

      } finally {
        setSubmitting(false);
      }
    };


  return (
    <div style={pageStyles.page}>
      <div style={pageStyles.container}>

        <div style={pageStyles.header}>
          <button
            style={pageStyles.backButton}
            onClick={goBackToHome}
          >
            {content.back}
          </button>

          <div style={pageStyles.headerIcon}>
            ✉️
          </div>

          <div style={pageStyles.eyebrow}>
            {content.eyebrow}
          </div>

          <h1 style={pageStyles.title}>
            {content.title}
          </h1>

          <p style={pageStyles.subtitle}>
            {content.subtitle}
          </p>
        </div>


        <div style={pageStyles.mainGrid}>

          <div style={pageStyles.infoCard}>

            <div style={pageStyles.infoHeader}>
              <h2 style={pageStyles.cardTitle}>
                {content.helpTitle}
              </h2>

              <p style={pageStyles.cardDescription}>
                {content.helpDescription}
              </p>
            </div>


            <div style={pageStyles.infoItem}>
              <div style={pageStyles.infoIcon}>
                ✉️
              </div>

              <div>
                <div style={pageStyles.infoTitle}>
                  {content.emailTitle}
                </div>

                <a
                  href="mailto:supports@acemassagehub.com"
                  style={pageStyles.emailLink}
                >
                  supports@acemassagehub.com
                </a>

                <div style={pageStyles.infoText}>
                  {content.responseTime}
                </div>
              </div>
            </div>


            <div style={pageStyles.infoItem}>
              <div style={pageStyles.infoIcon}>
                🕐
              </div>

              <div>
                <div style={pageStyles.infoTitle}>
                  {content.supportHoursTitle}
                </div>

                <div style={pageStyles.infoTextStrong}>
                  {content.supportDays}
                </div>

                <div style={pageStyles.infoText}>
                  {content.supportHours}
                </div>
              </div>
            </div>


            <div style={pageStyles.infoItem}>
              <div style={pageStyles.infoIcon}>
                💬
              </div>

              <div>
                <div style={pageStyles.infoTitle}>
                  {content.commonInquiriesTitle}
                </div>

                <div style={pageStyles.inquiryList}>
                  {content.commonInquiries.map(
                    (inquiry, index) => (
                      <div key={index}>
                        • {inquiry}
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>


            <div style={pageStyles.responseNote}>
              <div style={pageStyles.responseNoteIcon}>
                ✓
              </div>

              <div>
                <div style={pageStyles.responseNoteTitle}>
                  {content.helpNoteTitle}
                </div>

                <div style={pageStyles.responseNoteText}>
                  {content.helpNoteText}
                </div>
              </div>
            </div>

          </div>


          <div style={pageStyles.formCard}>

            <div style={pageStyles.formHeader}>
              <h2 style={pageStyles.cardTitle}>
                {content.formTitle}
              </h2>

              <p style={pageStyles.cardDescription}>
                {content.formDescription}
              </p>
            </div>


            <form onSubmit={handleSubmit}>

              <div style={pageStyles.twoColumnGrid}>

                <div>
                  <label style={pageStyles.label}>
                    {content.nameLabel}
                  </label>

                  <input
                    type="text"
                    value={name}
                    onChange={(event) =>
                      setName(
                        event.target.value
                      )
                    }
                    placeholder={
                      content.namePlaceholder
                    }
                    style={pageStyles.input}
                  />
                </div>


                <div>
                  <label style={pageStyles.label}>
                    {content.emailLabel}
                  </label>

                  <input
                    type="email"
                    value={email}
                    onChange={(event) =>
                      setEmail(
                        event.target.value
                      )
                    }
                    placeholder={
                      content.emailPlaceholder
                    }
                    style={pageStyles.input}
                  />
                </div>

              </div>


              <div style={pageStyles.formGroup}>
                <label style={pageStyles.label}>
                  {content.subjectLabel}
                </label>

                <select
                  value={subject}
                  onChange={(event) =>
                    setSubject(
                      event.target.value
                    )
                  }
                  style={pageStyles.input}
                >
                  <option value="">
                    {content.selectSubject}
                  </option>

                  <option value="Account & Subscription">
                    {content.subjects.account}
                  </option>

                  <option value="Technical Support">
                    {content.subjects.technical}
                  </option>

                  <option value="Practice Questions">
                    {content.subjects.practice}
                  </option>

                  <option value="AI Explanations">
                    {content.subjects.ai}
                  </option>

                  <option value="Continuing Education">
                    {content.subjects.ce}
                  </option>

                  <option value="General Feedback">
                    {content.subjects.feedback}
                  </option>

                  <option value="Other">
                    {content.subjects.other}
                  </option>
                </select>
              </div>


              <div style={pageStyles.formGroup}>
                <label style={pageStyles.label}>
                  {content.messageLabel}
                </label>

                <textarea
                  value={message}
                  onChange={(event) =>
                    setMessage(
                      event.target.value
                    )
                  }
                  placeholder={
                    content.messagePlaceholder
                  }
                  rows={8}
                  style={pageStyles.textarea}
                />
              </div>


              <button
                type="submit"
                disabled={submitting}
                style={{
                  ...pageStyles.sendButton,

                  ...(submitting
                    ? pageStyles.sendButtonDisabled
                    : {}),
                }}
              >
                {submitting
                  ? content.sending
                  : content.sendMessage}
              </button>


              <div style={pageStyles.formFooter}>
                {content.formFooter}
              </div>

            </form>
          </div>

        </div>


        <div style={pageStyles.bottomStrip}>

          <div style={pageStyles.bottomStripIcon}>
            🌿
          </div>

          <div>
            <div style={pageStyles.bottomStripTitle}>
              {content.bottomTitle}
            </div>

            <div style={pageStyles.bottomStripText}>
              {content.bottomText}
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}


// ============================================================
// STYLES
// ============================================================

const pageStyles = {

  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(180deg, #f7f9fc 0%, #ffffff 100%)",
    padding:
      "32px 18px 60px",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    color:
      "#172033",
  },

  container: {
    width:
      "100%",
    maxWidth:
      "1100px",
    margin:
      "0 auto",
  },

  header: {
    marginBottom:
      "28px",
  },

  backButton: {
    border:
      "none",
    background:
      "transparent",
    color:
      "#2563eb",
    cursor:
      "pointer",
    padding:
      0,
    marginBottom:
      "24px",
    fontSize:
      "14px",
    fontWeight:
      700,
  },

  headerIcon: {
    width:
      "54px",
    height:
      "54px",
    display:
      "flex",
    alignItems:
      "center",
    justifyContent:
      "center",
    borderRadius:
      "17px",
    background:
      "#eaf1ff",
    fontSize:
      "25px",
    marginBottom:
      "16px",
  },

  eyebrow: {
    color:
      "#2563eb",
    fontSize:
      "12px",
    fontWeight:
      800,
    letterSpacing:
      "1.8px",
    marginBottom:
      "8px",
  },

  title: {
    margin:
      "0 0 12px",
    fontSize:
      "38px",
    fontWeight:
      850,
    letterSpacing:
      "-0.8px",
  },

  subtitle: {
    margin:
      0,
    maxWidth:
      "720px",
    color:
      "#64748b",
    fontSize:
      "17px",
    lineHeight:
      1.7,
  },

  mainGrid: {
    display:
      "grid",
    gridTemplateColumns:
      "minmax(280px, 0.85fr) minmax(0, 1.4fr)",
    gap:
      "22px",
    alignItems:
      "stretch",
  },

  infoCard: {
    background:
      "linear-gradient(135deg, #f8fbff 0%, #ffffff 100%)",
    border:
      "1px solid #e2e8f0",
    borderRadius:
      "20px",
    padding:
      "28px",
    boxShadow:
      "0 8px 28px rgba(15,23,42,0.05)",
  },

  formCard: {
    background:
      "#ffffff",
    border:
      "1px solid #e2e8f0",
    borderRadius:
      "20px",
    padding:
      "30px",
    boxShadow:
      "0 8px 28px rgba(15,23,42,0.05)",
  },

  infoHeader: {
    marginBottom:
      "26px",
  },

  formHeader: {
    marginBottom:
      "24px",
  },

  cardTitle: {
    margin:
      "0 0 8px",
    fontSize:
      "23px",
    fontWeight:
      800,
  },

  cardDescription: {
    margin:
      0,
    color:
      "#64748b",
    fontSize:
      "14px",
    lineHeight:
      1.65,
  },

  infoItem: {
    display:
      "flex",
    gap:
      "15px",
    padding:
      "19px 0",
    borderBottom:
      "1px solid #edf2f7",
  },

  infoIcon: {
    flex:
      "0 0 auto",
    width:
      "42px",
    height:
      "42px",
    display:
      "flex",
    alignItems:
      "center",
    justifyContent:
      "center",
    borderRadius:
      "13px",
    background:
      "#eef4ff",
    fontSize:
      "18px",
  },

  infoTitle: {
    fontSize:
      "14px",
    fontWeight:
      800,
    marginBottom:
      "5px",
  },

  infoTextStrong: {
    fontSize:
      "13px",
    fontWeight:
      700,
    color:
      "#334155",
    marginBottom:
      "3px",
  },

  infoText: {
    color:
      "#64748b",
    fontSize:
      "13px",
    lineHeight:
      1.6,
  },

  emailLink: {
    display:
      "inline-block",
    color:
      "#2563eb",
    fontSize:
      "13px",
    fontWeight:
      700,
    textDecoration:
      "none",
    marginBottom:
      "3px",
    wordBreak:
      "break-word",
  },

  inquiryList: {
    color:
      "#64748b",
    fontSize:
      "13px",
    lineHeight:
      1.8,
  },

  responseNote: {
    display:
      "flex",
    gap:
      "12px",
    marginTop:
      "22px",
    padding:
      "16px",
    borderRadius:
      "14px",
    background:
      "#f2fbf5",
    border:
      "1px solid #dcf1e3",
  },

  responseNoteIcon: {
    width:
      "28px",
    height:
      "28px",
    flex:
      "0 0 auto",
    display:
      "flex",
    alignItems:
      "center",
    justifyContent:
      "center",
    borderRadius:
      "50%",
    background:
      "#dcfce7",
    color:
      "#15803d",
    fontWeight:
      800,
  },

  responseNoteTitle: {
    fontSize:
      "13px",
    fontWeight:
      800,
    marginBottom:
      "4px",
  },

  responseNoteText: {
    color:
      "#64748b",
    fontSize:
      "12px",
    lineHeight:
      1.55,
  },

  twoColumnGrid: {
    display:
      "grid",
    gridTemplateColumns:
      "repeat(2, minmax(0, 1fr))",
    gap:
      "16px",
    marginBottom:
      "18px",
  },

  formGroup: {
    marginBottom:
      "18px",
  },

  label: {
    display:
      "block",
    marginBottom:
      "7px",
    color:
      "#334155",
    fontSize:
      "13px",
    fontWeight:
      700,
  },

  input: {
    width:
      "100%",
    height:
      "48px",
    padding:
      "0 14px",
    boxSizing:
      "border-box",
    border:
      "1px solid #cbd5e1",
    borderRadius:
      "10px",
    background:
      "#ffffff",
    color:
      "#172033",
    fontSize:
      "14px",
    outline:
      "none",
  },

  textarea: {
    width:
      "100%",
    padding:
      "14px",
    boxSizing:
      "border-box",
    resize:
      "vertical",
    border:
      "1px solid #cbd5e1",
    borderRadius:
      "10px",
    background:
      "#ffffff",
    color:
      "#172033",
    fontSize:
      "14px",
    lineHeight:
      1.6,
    fontFamily:
      "inherit",
    outline:
      "none",
  },

  sendButton: {
    width:
      "100%",
    minHeight:
      "50px",
    border:
      "none",
    borderRadius:
      "11px",
    background:
      "#2563eb",
    color:
      "#ffffff",
    fontSize:
      "15px",
    fontWeight:
      800,
    cursor:
      "pointer",
    boxShadow:
      "0 8px 18px rgba(37,99,235,0.18)",
  },

  sendButtonDisabled: {
    opacity:
      0.6,
    cursor:
      "not-allowed",
  },

  formFooter: {
    marginTop:
      "11px",
    textAlign:
      "center",
    color:
      "#94a3b8",
    fontSize:
      "11px",
  },

  bottomStrip: {
    display:
      "flex",
    alignItems:
      "center",
    gap:
      "14px",
    marginTop:
      "22px",
    padding:
      "20px 22px",
    borderRadius:
      "17px",
    border:
      "1px solid #dcefe7",
    background:
      "linear-gradient(135deg, #f2fbf6 0%, #f4f8ff 100%)",
  },

  bottomStripIcon: {
    fontSize:
      "30px",
  },

  bottomStripTitle: {
    fontWeight:
      800,
    marginBottom:
      "4px",
  },

  bottomStripText: {
    color:
      "#64748b",
    fontSize:
      "13px",
  },
};